<template>
  <div></div>
</template>

<script>
export default {
  name: "EdNotify",
  components: {},
  data: () => ({
    visible: false,
    snackbar: {
      enabled: false,
      color: "success",
      mode: "multi-line",
      timeout: 4000,
      message: "Success!",
      callback: null,
      location: "bottom",
      close: {
        text: "Close",
        color: "",
      },
    },
  }),
  mounted() {
    this.$utilidade.console("::EdNotification module loaded::");
  },
  methods: {
    error(message, options = {}) {
      this.snackbar.message = message;
      this.snackbar.color = "error";
      this.setOptions(options);
    },

    success(message, options = {}) {
      this.snackbar.message = message;
      this.snackbar.color = "success";
      this.setOptions(options);
    },

    warning(message, options = {}) {
      this.snackbar.message = message;
      this.snackbar.color = "warning";
      this.setOptions(options);
    },

    info(message, options = {}) {
      this.snackbar.message = message;
      this.snackbar.color = "primary";
      this.setOptions(options);
    },

    hide() {
      this.visible = false;
      if (this.snackbar.callback) {
        this.snackbar.callback();
      }
    },

    setOptions(options = {}) {
      this.$message({
        message: this.snackbar.message,
        type: this.snackbar.color,
      });
    },

    reset() {
      this.$destroy();
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdNotify.vue?d3fa5e3c